module.exports = __webpack_public_path__ + "assets/img/json_tree.931b8829.png";